import TalkRegistration from "../registration/talkRegistration/talkRegistration";
import { EventCard } from "components/eventCard/eventCard";
import { AddToCalendar } from "components/addToCalendar/addToCalendar";
import { TalkBody } from "components/eventCard/talkElements";
import type { TalkData } from "content-ui/talks/types";

const UpcomingTalks = ({
  upcomingTalks,
  heading,
}: {
  upcomingTalks: TalkData[];
  heading: string;
}) => {
  return (
    <>
      <h2 className="mb-[10px] font-bold text-[18px]">{heading}</h2>
      <div className="space-y-5">
        {upcomingTalks.map((talk, i) => {
          const talkTime = new Date(talk.dateTime);
          return (
            <div key={talk.id} data-cy={`upcoming-talk-${i + 1}`}>
              <EventCard
                chevronClasses="hidden lg:flex"
                cardLink={`/talks/${talk.slug}`}
                image={talk.image}
                sponsorImage={talk?.sponsorLogo}
                sponsorDetails={talk?.sponsorDetails}
                heading={talk.marketLabel}
                title={talk.title}
                excerpt={talk.excerpt}
                body={<TalkBody talk={talk} />}
                registration={<TalkRegistration talk={talk} />}
                eventDateTime={talkTime}
                variant="talk"
                duration={talk.duration}
                withDuration={true}
                timezone={["Europe/London", "Europe/Brussels"]}
                calendar={
                  <AddToCalendar
                    event={talk}
                    classNames="text-[#767683] [&>span]:ml-md space-x-[20px]"
                    type="talk"
                  />
                }
              />
            </div>
          );
        })}
      </div>
      <div className="my-[50px] border-b-[1px] border-[#C8C8CC]"></div>
    </>
  );
};

export default UpcomingTalks;
